/**
 * 検索ページ: タブ切り替え ＋ エリア選択アコーディオン
 * - タブ: .searchHeader__tab クリックでパネル表示切替（hidden / aria-selected / is-active）
 * - 詳細条件（SearchAddOptions）: 物件種別タブに合わせて bukken_list と同じ項目を表示（property-type-filter-fields）
 * - アコーディオン: jQuery slideDown / slideUp（.searchSelect__areaHead 付近クリック、ラベル除外）
 */
import { updatePropertyTypeFilterFields } from "./property-type-filter-fields.js";

const OPEN_CLASS = "is-open";
const ACCORDION_MS = 300;

const TAB_ID_TO_PROPERTY_TYPE = {
	"tab-new-house": "new",
	"tab-used-house": "used",
	"tab-mansion": "mansion",
	"tab-land": "land",
};

/** URL ?property= と searchHeader__tab の id 対応（トップモーダルからの遷移用） */
const PROPERTY_QUERY_TO_TAB_ID = {
	new: "tab-new-house",
	used: "tab-used-house",
	mansion: "tab-mansion",
	land: "tab-land",
};

function getActiveTabPropertyType(tabList) {
	const active =
		tabList.querySelector('.searchHeader__tab.is-active[aria-selected="true"]') ||
		tabList.querySelector(".searchHeader__tab.is-active");
	const id = active?.id;
	return (id && TAB_ID_TO_PROPERTY_TYPE[id]) || "new";
}

function syncSearchAddOptionsToPropertyType(tabList) {
	const root = document.querySelector("[data-search-add-options-fields]");
	if (!root || !tabList) return;
	const fields = Array.from(root.querySelectorAll("[data-bukken-filter-field]"));
	if (!fields.length) return;
	const type = getActiveTabPropertyType(tabList);
	updatePropertyTypeFilterFields(type, fields);
}

function activateSearchHeaderTab(tabList, tab) {
	if (!tabList || !tab) return;
	const tabs = tabList.querySelectorAll(".searchHeader__tab");
	const panelId = tab.getAttribute("aria-controls") || tab.getAttribute("href")?.slice(1);
	const targetPanel = panelId ? document.getElementById(panelId) : null;
	if (!targetPanel) return;

	tabs.forEach((t) => {
		t.classList.remove("is-active");
		t.setAttribute("aria-selected", "false");
	});
	tab.classList.add("is-active");
	tab.setAttribute("aria-selected", "true");

	document.querySelectorAll(".searchSelect__form[role='tabpanel']").forEach((panel) => {
		if (panel === targetPanel) {
			panel.removeAttribute("hidden");
		} else {
			panel.setAttribute("hidden", "");
		}
	});

	syncSearchAddOptionsToPropertyType(tabList);
}

export function init() {
	// タブ切り替え（パネル表示 ＋ active と aria-selected の切り替え）
	const tabList = document.querySelector(".searchHeader__tabs");
	if (tabList) {
		const tabs = tabList.querySelectorAll(".searchHeader__tab");
		tabs.forEach((tab) => {
			tab.addEventListener("click", (e) => {
				e.preventDefault();
				activateSearchHeaderTab(tabList, tab);
			});
		});

		const param = new URLSearchParams(window.location.search).get("property");
		if (param && PROPERTY_QUERY_TO_TAB_ID[param]) {
			const targetTab = tabList.querySelector(`#${PROPERTY_QUERY_TO_TAB_ID[param]}`);
			if (targetTab) {
				activateSearchHeaderTab(tabList, targetTab);
			} else {
				syncSearchAddOptionsToPropertyType(tabList);
			}
		} else {
			syncSearchAddOptionsToPropertyType(tabList);
		}
	}

	// エリアアコーディオン（jQuery slide）
	if (typeof window.$ !== "undefined") {
		const $ = window.$;

		$("[data-accordion]").each(function () {
			const $area = $(this);
			const $content = $area.find("[data-accordion-content]");
			if (!$content.length) return;
			if ($area.hasClass(OPEN_CLASS)) {
				$content.show();
			} else {
				$content.hide();
			}
			const el = $content.get(0);
			if (el) {
				el.setAttribute("aria-hidden", $area.hasClass(OPEN_CLASS) ? "false" : "true");
			}
		});

		$(document)
			.off("click.searchSelectAccordion", "[data-accordion-trigger]")
			.on("click.searchSelectAccordion", "[data-accordion-trigger]", function (e) {
				if ($(e.target).closest(".searchSelect__areaHeadLabel").length) return;

				const $area = $(this).closest("[data-accordion]");
				const $content = $area.find("[data-accordion-content]");
				if (!$content.length) return;

				const isOpen = $area.hasClass(OPEN_CLASS);

				if (isOpen) {
					$content.attr("aria-hidden", "true");
					$content.stop(true, false).slideUp(ACCORDION_MS, function () {
						$area.removeClass(OPEN_CLASS);
					});
				} else {
					$content.hide();
					$area.addClass(OPEN_CLASS);
					$content.attr("aria-hidden", "false");
					$content.stop(true, false).slideDown(ACCORDION_MS);
				}
			});
	}
}
